import { useEffect, useState } from "react";
import { useAppSelector } from "src/hooks/redux";
const useMaxOiHook = (optionArray) => {
    const [callMaxOi, setCallMaxOi] = useState(0);
    const [putMaxOi, setPutMaxOi] = useState(0);
    useEffect(() => {
        let localPutMaxOi = 0;
        let localCallMaxOi = 0;
        // console.log("This is a tribute 2");
        // console.log("tribute optionArray : ", JSON.stringify(optionArray));
        optionArray.forEach((optionElement) => {
            if (optionElement.CPType == "PE") {
                if (Number(localPutMaxOi) < Number(optionElement.OpenInterest)) {
                    localPutMaxOi = optionElement.OpenInterest;
                }
            }
            else {
                if (Number(localCallMaxOi) < Number(optionElement.OpenInterest)) {
                    localCallMaxOi = optionElement.OpenInterest;
                }
            }
        });
        setPutMaxOi(localPutMaxOi);
        setCallMaxOi(localCallMaxOi);
    }, [optionArray]);
    // useEffect(() => { });
    useAppSelector((state) => {
        if (state.openFeedWs.message) {
            let update = state.openFeedWs.message;
            if (Array.isArray(update)) {
                update = update[0];
            }
            if (update.OpenInterest !== undefined) {
                const optionElement = optionArray.find((singleElement) => {
                    return singleElement.ScripCode == update.Token;
                });
                if (optionElement != undefined) {
                    if (optionElement.CPType == "PE") {
                        if (putMaxOi < update.OpenInterest) {
                            setPutMaxOi(update.OpenInterest);
                        }
                    }
                    else {
                        if (callMaxOi < update.OpenInterest) {
                            setCallMaxOi(update.OpenInterest);
                        }
                    }
                }
            }
            // return state.openFeedWs.message;
            //
            return undefined;
        }
    });
    return { callMaxOi, putMaxOi };
};
export default useMaxOiHook;
